import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const gallery = {
  createGallery: lazyModuleMethod(() => import('./createGallery'), 'default'),
  createGalleryPhoto: lazyModuleMethod(
    () => import('./createGalleryPhoto'),
    'default'
  ),
  deleteGallery: lazyModuleMethod(() => import('./deleteGallery'), 'default'),
  deleteGalleryPhoto: lazyModuleMethod(
    () => import('./deleteGalleryPhoto'),
    'default'
  ),
  editGallery: lazyModuleMethod(() => import('./editGallery'), 'default'),
  fetchGalleries: lazyModuleMethod(() => import('./fetchGalleries'), 'default'),
  fetchGallery: lazyModuleMethod(() => import('./fetchGallery'), 'default'),
  updateGalleryPhoto: lazyModuleMethod(
    () => import('./updateGalleryPhoto'),
    'default'
  ),
  updateMainGalleryPhoto: lazyModuleMethod(
    () => import('./updateMainGalleryPhoto'),
    'default'
  ),
}
